import React from "react";

import type { ErrorProps } from "./Error";
import { Error } from "./Error";
import type { LoadingProps } from "./Loading";
import { Loading } from "./Loading";

type LoadingErrorProps = Partial<LoadingProps> & Partial<ErrorProps>;

export const LoadingError = (props: LoadingErrorProps) => {
    const {
        className,
        error,
        hasError,
        hasPartialError,
        isLoading,
        isPartiallyLoading,
        isSuccessful,
        isPartiallySuccessful,
        data,
        keepMounted,
        ...otherProps
    } = props;

    return keepMounted || isLoading || isPartiallyLoading || hasError || hasPartialError ? (
        <div className={className}>
            <Loading
                {...{
                    error,
                    hasError,
                    hasPartialError,
                    isLoading,
                    isPartiallyLoading,
                    isSuccessful,
                    isPartiallySuccessful,
                    keepMounted,
                }}
                {...otherProps}
            />
            {hasError && error && <Error error={error} {...otherProps} />}
        </div>
    ) : null;
};
